module.exports = __webpack_public_path__ + "static/media/viewnotes.50e0e582.apk";